import { FETCH_FILES } from "../actions/types";

var initialState = {
  items: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FILES:
      return {
        ...state,
        items: action.payload,
      };
    default:
      return state;
  }
};
